.panel {
  background: var(--surface);
  border-radius: var(--radius);
  padding: 24px;
  min-width: 0;
}

.heading {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}

.headLabel {
  font-family: var(--font-display);
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text);
}

.badge,
.badgeLocal {
  font-size: 0.78rem;
  font-weight: 600;
  border-radius: 999px;
  padding: 2px 10px;
  white-space: nowrap;
}

.badge {
  color: var(--amber-strong);
  background: var(--amber-dim);
  border: 1px solid var(--amber-border);
}

.badgeLocal {
  color: var(--soft);
  background: var(--tint-md);
  border: 1px solid var(--border-md);
}

/* Deliberately first and never collapsed: the profile is usually someone
   else's, so the send is stated before the text it produced. */
.disclosure {
  font-size: 0.85rem;
  line-height: 1.5;
  color: var(--muted);
  border-left: 2px solid var(--border-md);
  padding-left: 12px;
  margin-bottom: 18px;
}

.notice {
  padding: 10px 14px;
  margin-bottom: 16px;
  font-size: 0.88rem;
  color: #7A4E0C;
  background: rgba(217, 126, 36, 0.12);
  border: 1px solid rgba(217, 126, 36, 0.35);
  border-radius: var(--radius-sm);
}

.error {
  padding: 10px 14px;
  margin-top: 12px;
  font-size: 0.9rem;
  color: var(--down);
  background: var(--down-dim);
  border: 1px solid var(--down);
  border-radius: var(--radius-sm);
}

/* Nothing is sent until this is pressed, which is the point of the disclosure
   sitting directly above it. */
.generate {
  padding: 10px 20px;
  font-size: 0.93rem;
  font-weight: 600;
  color: var(--canvas);
  background: var(--amber);
  border-radius: var(--radius-sm);
}

.prose {
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: 0.95rem;
  line-height: 1.65;
  color: var(--text);
  max-width: 72ch;
}

.bullets {
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.contextDetails {
  margin-top: 18px;
}

.contextSummary {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--muted);
  cursor: pointer;
}

.contextJson {
  margin: 10px 0 0;
  padding: 14px;
  max-height: 320px;
  overflow: auto;
  font-family: var(--font-mono);
  font-size: 0.76rem;
  line-height: 1.5;
  color: var(--soft);
  background: var(--surface-2);
  border-radius: var(--radius-sm);
}

.chat {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 22px;
  padding-top: 20px;
  border-top: 1px solid var(--border);
}

.userTurn {
  align-self: flex-end;
  max-width: 80%;
  padding: 9px 14px;
  font-size: 0.92rem;
  color: var(--text);
  background: var(--amber-dim);
  border: 1px solid var(--amber-border);
  border-radius: var(--radius-sm);
}

.replyTurn {
  align-self: flex-start;
  max-width: 88%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 0.93rem;
  line-height: 1.6;
  color: var(--text);
}

.composer {
  display: flex;
  gap: 10px;
  align-items: center;
}

.input {
  flex: 1;
  min-width: 0;
  padding: 10px 14px;
  font-size: 0.93rem;
  color: var(--text);
  background: var(--canvas);
  border: 1px solid var(--border-md);
  border-radius: var(--radius-sm);
}

.input::placeholder { color: var(--muted); }

.send {
  padding: 10px 20px;
  font-size: 0.92rem;
  font-weight: 600;
  color: var(--canvas);
  background: var(--amber);
  border-radius: var(--radius-sm);
}

.footnote {
  font-size: 0.8rem;
  color: var(--muted);
}
